<template>
    <div class="memory-form" :class="{ 'memory-form--sending': sending }" v-if="formVisible">
        <div class="memory__overlay" :class="{ 'memory__overlay--show-success': memoryPlaced }">
            <div class="memory__overlay-text">
                <i class="icon-star-david"></i>
                <h3 class="thankyou">{{ $t('thank-you-gift') }}</h3>
                <h2 class="bid">${{donationAmount.value}}</h2>
                <span class="for">{{ $t('for') }}</span>
                <h4 class="title">{{ $t('yizkor') }}</h4>
                <span class="close" @click="close">{{ $t('close') }}</span>
            </div>
        </div>
        <div class="memory-form__util">
            <div class="memory-form__util--close" @click="close"><span class="icon-close"></span></div>
        </div>

        <div class="memory-form__step" :class="{ 'show': step1 }">
            <div class="memory-form__header">
                <h5 class="memory-form__headline memory-form__headline--step-1">{{ $t('leave-memory') }}</h5>
                <span class="memory-form__pagination">{{ $t('step-progress', { step: step, total: 2 }) }}</span>
            </div>
            <div class="memory-form__person">
                <div class="form-field">
                    <div class="form-control">
                        <Input :data="lovedOne"/>
                    </div>
                </div>

                <div class="form-field">
                    <div class="form-control">
                        <Input :data="datePassed"/>
                    </div>
                </div>

                <div class="form-field form-row">
                    <div class="form-control form-column">
                        <Input :data="hebrewName"/>
                    </div>
                    <div class="form-control form-column">
                        <Input :data="hebrewNameFather"/>
                    </div>
                </div>
            </div>

            <div class="form-field">
                <div class="form-control">
                    <div class="form-upload--hasbtn">
                        <input class="form-input" type="file" @change="uploadFile($event)">
                        <button class="memory-person__btn memory-person__btn--paperclip" tabindex="-1">{{fileText ? `${fileText}` :
                            $t('add-photo')}}
                        </button>
                    </div>
                </div>
            </div>

            <!--<MemoryPerson :people="people" :max="5"/>-->

            <div class="form-field">
                <div class="form-control">
                    <TextArea :data="message"/>
                </div>
            </div>

            <button class="btn btn--primary btn--fluid mt-2" @click="nextStep" :disabled="!isValid">
                {{ isPledgeOnly ? $t('next-pledge-info') : $t('next-donation-info') }}
            </button>
        </div>

        <div class="memory-form__step" :class="{ 'show': step2 }">
            <div class="memory-form__header">
                <h5 class="memory-form__headline">{{ $t('donation-information') }}</h5>
                <a class="memory-form__back" @click="prevStep"><span class="icon-chevron-left"></span>
                  {{ $t('back-to-details') }}
                </a>
                <span class="memory-form__pagination">{{ $t('step-progress', { step: step, total: 2 }) }}</span>
            </div>

            <div class="form-field">
                <div class="form-control">
                    <Input :data="donationAmount" bid choose-enter :choose-options="donationOptions"/>
                </div>
            </div>

            <PurchaseForm class="mt-1" memory payment :donation-valid="donationAmount.valid" :pledge="cause.is_accepting_pledges" :echeck="cause.is_accepting_echeck" :card="cause.is_accepting_card" />
            <div class="align-center mt-1">
                <pulse-loader color="#A19378" :loading="sending"/>
            </div>
            <span class="form-error mt-1" v-if="error">Oops!  There was an error: {{errorMsg}}</span>
        </div>

    </div>
</template>

<script>
  import {EventBus} from "../../eventbus";
  import Input from '../inputs/Input';
  import TextArea from "../inputs/TextArea";
  // import MemoryPerson from '../inputs/MemoryPerson';
  import PurchaseForm from './PurchaseForm';
  import {mapState} from 'vuex';
  import {log} from '../../utilities/log';
  import axios from "axios";
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

  export default {
    name: 'MemoryForm',

    props: {
      page: Number
    },

    components: {
      Input,
      TextArea,
      // MemoryPerson,
      PulseLoader,
      PurchaseForm
    },

    data: () => {
      return {
        donationOptions: Array,
        memoryPlaced: false,
        step: 1,
        image: null,
        memoryData: {},
        error: false,
        errorMsg: null,
        formVisible: '',
        sending: false,
        fileText: null
      }
    },

    computed: {
      ...mapState({
        causes: state => state.causes,
        lovedOne: state => state.memoryForm.lovedOne,
        datePassed: state => state.memoryForm.datePassed,
        hebrewName: state => state.memoryForm.hebrewName,
        hebrewNameFather: state => state.memoryForm.hebrewNameFather,
        message: state => state.memoryForm.message,
        people: state => state.memoryForm.people,
        donationAmount: state => state.memoryForm.donationAmount,
        payment: state => state.purchaseForm,
        subdomain: state => state.subdomain,
        memoryForm: state => state.memoryForm
      }),
      cause: function () {
        return this.causes.filter((cause) => cause.id === this.$route.params.cause_id)[0];
      },
      isPledgeOnly: function() {
        return this.cause.is_accepting_pledges && !this.cause.is_accepting_card && !this.cause.is_accepting_echeck;
      },
      isValid: function () {
        const lovedOne = this.lovedOne.valid;
        const datePassed = this.datePassed.valid;
        const hebrewName = this.hebrewName.valid;
        const hebrewNameFather = this.hebrewNameFather.valid;
        // const people = this.validatePeople(this.people);

        return lovedOne && datePassed && hebrewName && hebrewNameFather;
      },
      step1: function () {
        return this.step === 1;
      },
      step2: function () {
        return this.step === 2;
      }
    },

    mounted: function () {
      EventBus.$on('memory-form-toggle', (data) => {
        this.formVisible = data.formVisible;
        this.donationOptions = data.donation_options;
      });

      EventBus.$on('leave-memory', this.leaveMemory);
    },
    beforeDestroy: function() {
      EventBus.$off('leave-memory', this.leaveMemory);
    },
    methods: {
      toBase64: function (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader);
          reader.onerror = error => reject(error);
        })
      },
      uploadFile: async function (e) {
        try {
          const files = e.target.files || e.dataTransfer.files;
          if (!files.length) {
            return;
          }
          const reader = await this.toBase64(files[0]);
          this.image = reader.result;
          this.fileText = files[0].name;
        } catch (err) {
          const msg = err.response ? err.response.data.errors[0].detail : err.message;
          EventBus.$emit('error', msg);
          log(`Error Uploading Memory Form Image: ${err}`, 'error');
          console.table(err.response.data.errors);
        }
      },
      focusTarget: function (el, offset, animate) {
        offset === undefined ? offset = 0 : offset;
        animate === undefined || animate === false ? animate = 'auto' : animate = 'smooth';
        const y = el.getBoundingClientRect().top + window.pageYOffset + offset;

        window.scrollTo({top: y, behavior: animate});
      },
      prevStep: function () {
        this.step = 1;
        this.focusTarget(this.$el, -32);
      },
      nextStep: function () {
        this.step = 2;
        this.focusTarget(this.$el, -32);

        this.memoryData = {
          lovedOne: this.lovedOne,
          datePassed: this.datePassed,
          hebrewName: this.hebrewName,
          hebrewNameFather: this.hebrewNameFather,
          message: this.message
        };
      },
      validatePeople: function (people) {
        const invalid = [];

        for (let i = 0; i < people.length; i++) {
          const keys = Object.keys(people[i]);
          for (const key of keys) {
            !people[i][key].valid && invalid.push(key);
          }
        }

        return invalid.length === 0;
      },
      close: async function () {
        try {
          // Close the actual form out, not just the success window.
          EventBus.$emit('memory-form-toggle', false);
          this.formVisible = null;

          this.step = 1;
          this.memoryPlaced = false;
          this.error = false;
          this.errorMsg = null;

          await this.$store.dispatch('updateMemoryForm', {
            data: this.memoryForm,
            form: 'memoryForm'
          }, {root: true});
        } catch(err) {
          log(`Error Resetting and Closing Form: ${err.message}`, 'error');
        }
      },
      leaveMemory: async function() {
        try {
          this.sending = true;

          let paymentInfo = {
            type: 'payment-profiles',
            is_charging_allowed: true
          };

          switch (this.payment.pay.selected) {
            case 'card':
              paymentInfo = {
                ...paymentInfo,
                is_echeck: false,
                first_name: this.payment.cardName.value.split(' ')[0],
                last_name: this.payment.cardName.value.split(' ')[1],
                email: this.payment.purchaseEmail.value,
                number: this.payment.cardNumber.value.replace(/-/g, ''),
                expiration: this.payment.exp.value,
                verification_value: this.payment.cvv.value,
                zipcode: this.payment.zip.value,
              };
              break;
            case 'echeck':
              paymentInfo = {
                ...paymentInfo,
                is_echeck: true,
                account_name: this.payment.accountName.value,
                account_number: this.payment.accountNumber1.value,
                account_number_confirmation: this.payment.accountNumber2.value,
                routing_number: this.payment.routingNumber.value
              };
          }

          // let people = this.people.map((person) => {
          //   const date = new Date(person.datePassed.value);
          //
          //   return {
          //     memorial_date: date.toISOString().split('T')[0],
          //     name_of_loved: person.lovedOne.value,
          //     hebrew_name: person.hebrewName.value,
          //     fathers_hebrew_name: person.hebrewNameFather.value
          //   }
          // });

          let people = [{
            memorial_date: new Date(this.datePassed.value).toUTCString(),
            name_of_loved: this.lovedOne.value,
            hebrew_name: this.hebrewName.value,
            fathers_hebrew_name: this.hebrewNameFather.value
          }];

          let name = null;

          switch (this.payment.pay.selected) {
            case 'card':
              name = this.payment.cardName.value;
              break;
            case 'echeck':
              name = this.payment.accountName.value;
              break;
            case 'pledge':
              name = this.payment.purchaseName.value;
              break;
          }

          let submissionData = {
            source: this.payment.pay.selected,
            donor_email: this.payment.purchaseEmail.value,
            donor_first_name: name.split(' ')[0],
            donor_last_name: name.split(' ')[1],
            cause_id: this.cause.id,
            amount_cents:  parseFloat(this.donationAmount.value.replace(/,/g, '')) * 100,
            donation_dedication_attributes: {
              message: this.message.value,
              dedication_type: 'memory',
              donation_dedication_memorials_attributes: people
            }
          };

          if (this.payment.pay.selected === 'card' || this.payment.pay.selected === 'echeck') {
            submissionData = {
              ...submissionData,
              included: [{...paymentInfo}]
            }
          }

          if (this.image !== null) {
            submissionData.donation_dedication_attributes.memorial_image_data_uri = this.image;
          }

          if (this.payment.fulfill.selected === 'nominate') {
            submissionData.nominee_fullname = this.payment.fulfill.options[1].input.value;
          }

          let resp = null;

          if (!this.payment.installments.options[0].checked) {

            resp = await axios.post(`https://${this.subdomain}.${process.env.VUE_APP_API_BASE_URL}/donations`, submissionData, {
              headers: {
                'X-JC-Source': 'raisesouls'
              }
            });

            log('Memory Form Submission Data:', 'debug');
            console.table(submissionData);

          } else {
            const installmentsCount = this.payment.installments.options[0].input.selected;
            const beginDate = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();

            submissionData = {
              ...submissionData,
              amount_cents: this.donationAmount.value / installmentsCount * 100,
              repeat_interval: 'monthly',
              max_repeat_count: installmentsCount,
              starts_at: beginDate,
              next_charge_at: beginDate
            };

            log('Memory Form Submission Data:', 'debug');
            console.table(submissionData);

            resp = await axios.post(`https://${this.subdomain}.${process.env.VUE_APP_API_BASE_URL}/recurring_donations`, submissionData, {
              headers: {
                'X-JC-Source': 'raisesouls'
              }
            });
          }

          log('Memory Form Submission Response:', 'debug');
          console.log(resp);

          if (resp.status === 201) {
            EventBus.$emit('success');
            await this.$store.dispatch('updateMemoriesEndless', { cause_id: this.$route.params.cause_id, page: this.page }, { root: true });
            this.memoryPlaced = true;
            this.sending = false;
          }
        } catch (err) {
          this.sending = false;
          const msg = err.response ? err.response.data.errors[0].detail : err.message;
          EventBus.$emit('error', msg);
          log(`Error Submitting Memory Form: ${err}`, 'error');
          console.table(err.response.data.errors);
        }
      }
    }
  }
</script>
